// Who an operator should contact when the app blocks them or a setting is
// controlled by someone else. Shown in permission/config hints across the app.
//
// The live value is stored server-side (siteSettings) and editable by an
// administrator under Admin → Support Contact. The values below are only the
// fallback used before the server responds, or if nothing has been saved yet.
export const defaultSupportContact = {
  name: 'Meronex Support',
  email: 'ali@meronex.com',
  phone: '',
};

// Populated from the server on load — see loadSupportContact().
let activeContact = { ...defaultSupportContact };

export const setSupportContact = (contact) => {
  // An admin can clear the fields; fall back rather than show a broken line.
  const hasAny = contact && (contact.name || contact.email || contact.phone);
  activeContact = hasAny ? { ...contact } : { ...defaultSupportContact };
};

export const getSupportContact = () => {
  const c = activeContact || {};
  const hasContactDetail = !!(c.email || c.phone);
  return {
    ...c,
    // A name with no way to reach them isn't actionable.
    hasNamedContact: !!(c.name && hasContactDetail),
  };
};

// One-line "who to ask", suitable for a hint under a disabled control.
export const supportContactLine = () => {
  const c = getSupportContact();
  if (!c.hasNamedContact) return 'Contact your administrator for access.';
  const via = c.email || c.phone;
  return `Need help? Ask ${c.name} (${via})`;
};
